import React from 'react';
import { Box, Alert, AlertIcon, Button, Text, HStack } from '@chakra-ui/react';

export default function ElasticsearchFallback({ featureName, onSwitch }) {
  const handleRetry = () => {
    window.location.reload();
  };

  return (
    <Box p={4}>
      <Alert status="error" flexDirection="column" alignItems="center" justifyContent="center" textAlign="center">
        <AlertIcon boxSize="40px" mr={0} />
        <Text fontWeight="bold" mt={4} mb={2}>
          Connection Error
        </Text>
        <Text mb={4}>
          The advanced {featureName} is currently unavailable. You can use the standard version as a backup or retry the connection.
        </Text>
        <HStack spacing={4}>
          <Button colorScheme="blue" onClick={onSwitch}>
            Switch to Standard {featureName}
          </Button>
          <Button colorScheme="gray" onClick={handleRetry}>
            Retry
          </Button>
        </HStack>
      </Alert>
    </Box>
  );
}
